import React from "react";
import styles from "./overlay.module.scss";
import SeatView from "../seatView";
import Loader from "../../loader";
import BusInfoView from "../busInfoView";

const OverlayScreen = props => {
  const {
    title,
    booking,
    seatLayout,
    content,
    busInfo,
    driverCabinSafetyEquipments
  } = props;
  let selectedSeats = {};
  let isUpperDeckOnly = false;
  if (content === "SEAT_LAYOUT") {
    selectedSeats = booking.tripChart.reduce((acc, seat) => {
      acc[seat.seatId] = true;
      return acc;
    }, {});
    const firstSeatId = booking.tripChart[0]?.seatId;
    isUpperDeckOnly = seatLayout.seatMap.upperDeck.seatGraph.some(row =>
      row.some(
        seat => seat && typeof seat === "object" && seat.id === firstSeatId
      )
    );
  }

  const renderContent = () => {
    const isFirstAidKitAvailable =
      booking?.trip?.service?.firstAidKits?.length > 0 ||
      driverCabinSafetyEquipments?.some(
        equipment => equipment === "FIRST_AID_KIT"
      );
    const isFireExtinguishersAvailable =
      (booking?.trip?.service?.fireExtinguishers &&
        booking?.trip?.service?.fireExtinguishers.length > 0) ||
      driverCabinSafetyEquipments?.some(
        equipment => equipment === "FIRE_EXTINGUISHER"
      );
    const emergencyHammersAvailable =
      (!!booking?.trip?.service?.emergencyHammers &&
        booking?.trip?.service?.emergencyHammers.some(
          hammer =>
            hammer.onEveryBackSeat ||
            hammer.onEveryWindowSeat ||
            (hammer.positions && hammer.positions.length > 0)
        )) ||
      driverCabinSafetyEquipments?.some(
        equipment => equipment === "EMERGENCY_HAMMER"
      );

    const isUpperDeckAvailable = seatLayout?.seatMap?.upperDeck?.available;

    const lowerDeckHammer = booking?.trip?.service?.emergencyHammers?.find(
      h => h.zIndex === 1
    );
    const upperDeckHammer = booking?.trip?.service?.emergencyHammers?.find(
      h => h.zIndex === 2
    );

    const lw =
      emergencyHammersAvailable && !!lowerDeckHammer?.onEveryWindowSeat;
    const lb = emergencyHammersAvailable && !!lowerDeckHammer?.onEveryBackSeat;
    const uw =
      emergencyHammersAvailable &&
      isUpperDeckAvailable &&
      !!upperDeckHammer?.onEveryWindowSeat;
    const ub =
      emergencyHammersAvailable &&
      isUpperDeckAvailable &&
      !!upperDeckHammer?.onEveryBackSeat;

    const getHammerText = () => {
      if (!lw && !lb && !uw && !ub) return null;
      // Case 9: window seats on both decks
      if (lw && !lb && uw && !ub)
        return "Emergency hammers are available on all window seats of both decks.";
      // Case 10: back seats on both decks
      if (!lw && lb && !uw && ub)
        return "Emergency hammers are available on all back seats.";
      const hasLower = lw || lb;
      const hasUpper = uw || ub;
      if (!hasUpper) {
        if (lw && lb)
          return "Emergency hammers are available on all window seats and all back seats.";
        return lw
          ? "Emergency hammers are available on all window seats."
          : "Emergency hammers are available on all back seats.";
      }
      if (!hasLower) {
        if (uw && ub)
          return "Emergency hammers are available on all window seats and all back seats of upper deck.";
        return uw
          ? "Emergency hammers are available on all window seats of upper deck."
          : "Emergency hammers are available on all back seats of upper deck.";
      }
      const lowerParts = [
        ...(lw ? ["all window seats"] : []),
        ...(lb ? ["all back seats"] : [])
      ];
      const upperParts = [
        ...(uw ? ["all window seats"] : []),
        ...(ub ? ["all back seats"] : [])
      ];
      return `Emergency hammers are available on ${lowerParts.join(
        " and "
      )} of lower deck and ${upperParts.join(" and ")} of upper deck.`;
    };
    const hammerText = getHammerText();

    switch (content) {
      case "SEAT_LAYOUT":
        return (
          <div>
            <div className={styles.headersWrapper}>
              <div className={styles.headers}>
                <div className={styles.seat}>
                  <img
                    src="https://d1flzashw70bti.cloudfront.net/original/images/seatLayout/icon-seat-selected.svg"
                    alt="selected seat"
                  />
                  <span>Your Seats</span>
                </div>
                {isFirstAidKitAvailable && (
                  <div>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/first-aid-kit.svg"
                      alt="first aid kit"
                    />
                    <span>First aid kit</span>
                  </div>
                )}
                {isFireExtinguishersAvailable && (
                  <div>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/fire-extinguisher.svg"
                      alt="fire extinguisher"
                    />
                    <span>Fire Extinguisher</span>
                  </div>
                )}
                {emergencyHammersAvailable && (
                  <div>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/hammer.svg"
                      alt="hammer"
                    />
                    <span>Emergency hammer</span>
                  </div>
                )}
              </div>
            </div>
            {hammerText && (
              <div className={styles.subHeader}>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/infoo.svg"
                  alt="info"
                />
                <span>{hammerText}</span>
              </div>
            )}

            <SeatView
              isUpperDeckOnly={isUpperDeckOnly}
              seat={seatLayout}
              driverCabinSafetyEquipments={driverCabinSafetyEquipments}
              noOfDeck={seatLayout.seatMap.upperDeck.available ? 2 : 1}
              mobileView={true}
              showLegend={false}
              seatSelected={selectedSeats}
            />
          </div>
        );

      case "BUS_INFO":
        return <BusInfoView data={busInfo[0]} setEvent={props.setEvents} />;

      default:
        return null;
    }
  };

  if (!seatLayout && content === "SEAT_LAYOUT") return <Loader />;
  if (!busInfo && content === "BUS_INFO") return <Loader />;

  return (
    <div className={styles.overlayContainer}>
      <div className={styles.header}>
        <button onClick={() => props.onClose()}>
          <img
            src={
              "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/backCLose.svg"
            }
            alt="back"
          />
        </button>
        <span>{title}</span>
        <button onClick={() => props.onClose()}>
          <img
            src={
              "https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/closr.svg"
            }
            alt="back"
          />
        </button>
      </div>

      {renderContent()}
    </div>
  );
};

export default OverlayScreen;
